import { useEffect, useState } from "react"

export const useObjectUrl = (blob) => {
  const [url, setUrl] = useState(null)

  useEffect(() => {
    if (!blob) {
      return undefined
    }
    const objectUrl = URL.createObjectURL(blob)
    setUrl(objectUrl)

    return () => URL.revokeObjectURL(objectUrl)
  }, [blob])

  return url
}
